import React, { JSX } from 'react';
import { useForm } from 'react-hook-form';
import { Button } from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormFooter } from 'common/components';
import { useTranslations } from 'contexts/LocalizationContext';
import * as yup from 'yup';

import FormInput from '../../common/components/FormInput/FormInput';

type MessageFormValues = {
  userId: string;
  content: string;
};

type MessagesFormProps = {
  isLoading: boolean;
  onSubmit: (values: MessageFormValues) => void;
};

const MessagesForm = ({ isLoading, onSubmit }: MessagesFormProps): JSX.Element => {
  const translations = useTranslations();

  const validationSchema = yup.object().shape({
    userId: yup.string().required(translations('validation_required')),
    content: yup.string().required(translations('validation_required')),
  });

  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue,
  } = useForm<MessageFormValues>({
    resolver: yupResolver(validationSchema),
  });

  return (
    <form data-testid="messages-form" onSubmit={handleSubmit(onSubmit)} autoComplete="off">
      <FormInput
        id="userId"
        label={translations('messages_form_user_id')}
        validationError={errors.userId?.message}
        useFormRegisterReturn={register('userId')}
        setValue={setValue}
        placeholder={translations('messages_form_user_id_placeholder')}
      />

      <FormInput
        id="content"
        label={translations('messages_form_content')}
        validationError={errors.content?.message}
        useFormRegisterReturn={register('content')}
        setValue={setValue}
        placeholder={translations('messages_form_content_placeholder')}
        textarea
        rows={5}
      />

      <FormFooter hasCustomContent={true}>
        <>
          <Button mr={4} isLoading={isLoading} type="submit">
            {translations('messages_form_submit')}
          </Button>
        </>
      </FormFooter>
    </form>
  );
};

export default MessagesForm;
